import { HStack, Stat } from "@chakra-ui/react";

import { BindingsImportPreviewType } from "@/codegen/openapi2";

type PreviewCountsProps = {
  preview: BindingsImportPreviewType;
};
export const PreviewCounts = ({ preview }: PreviewCountsProps) => {
  const counts = [
    { label: "Transferts", value: preview.counts.transfer },
    { label: "Créations", value: preview.counts.creation },
    { label: "Changements de type", value: preview.counts.type_change },
    { label: "Sans changement", value: preview.counts.unchanged },
    { label: "Erreurs", value: preview.counts.error },
    {
      label: "Communes de l'agence absentes du fichier",
      value: preview.agency_bindings_absent_from_file,
    },
  ];

  return (
    <HStack gap={4} wrap="wrap" align="stretch">
      {counts.map(({ label, value }) => (
        <Stat.Root key={label} borderWidth={1} rounded="md" p={4} maxW="220px">
          <Stat.Label>{label}</Stat.Label>
          <Stat.ValueText>{value}</Stat.ValueText>
        </Stat.Root>
      ))}
    </HStack>
  );
};
